class PhotoGalleryPopup extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        popupOverlay: ".photo-gallery-overlay",
        popupContainer: ".photo-gallery-container",
        carouselContainer: ".carousel-container",
        closeButton: ".photo-gallery-close",
        mainImages: ".images-pop img",
        carouselSlides: "[data-image-id]"
      };
    }
  
    connectedCallback() {
      console.log("photo gallery");
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      const mainImages = document.querySelectorAll(this.selectors.mainImages);
      mainImages.forEach((img) => {
        img.addEventListener("click", (event) => {
          const imageId = event.currentTarget.getAttribute("data-image-id");
          if (imageId) {
            const index = this.findImageIndex(imageId);
            this.openGallery(index);
          }
        });
      });
  
      const closeButton = this.querySelector(this.selectors.closeButton);
      if (closeButton) {
        closeButton.addEventListener("click", () => this.closeGallery());
      }
  
      const overlay = this.querySelector(this.selectors.popupOverlay);
      if (overlay) {
        overlay.addEventListener("click", (event) => {
          if (event.target.closest(".embla__button")) {
            return;
          }
          const container = this.querySelector(this.selectors.carouselContainer);
          if (container && !container.contains(event.target)) {
            this.closeGallery();
          }
        });
      }
  
      const carouselContainer = this.querySelector(this.selectors.carouselContainer);
      if (carouselContainer) {
        carouselContainer.addEventListener("click", (event) => {
          if (event.target.tagName.toLowerCase() === "img") {
            event.target.classList.toggle("zoomed");
          }
        });
      }
    }

    findImageIndex(imageId) {
      const slides = this.querySelectorAll(this.selectors.carouselSlides);
      for (let i = 0; i < slides.length; i++) {
        const slideImageId = slides[i].getAttribute("data-image-id");
        if (slideImageId === imageId) {
          return i;
        }
      }
      return 0;
    }
  
    openGallery(startIndex = 0) {
      const overlay = this.querySelector(this.selectors.popupOverlay);
      if (overlay) {
        overlay.classList.remove("hidden");
        document.body.style.overflow = "hidden";
  
        const carousel = this.querySelector("custom-carousel");
        if (carousel && carousel.embla) {
          carousel.embla.scrollTo(startIndex);
        }
      }
    }
  
    closeGallery() {
      const overlay = this.querySelector(this.selectors.popupOverlay);
      if (overlay) {
        overlay.classList.add("hidden");
        document.body.style.overflow = "";
      }
    }
  }
  
  customElements.define("photo-gallery-popup", PhotoGalleryPopup);
  